import React, { useRef, useState } from 'react'
import { ChildrenProps } from '../models/componentModel';
import { initialCreateNewFlowObject } from '../components/dashboard/workflow/workflowConstants';
import agent from '../services/api';
import { chatbotTypeResponseModel, CommonResponseModel, condition_group, createWorkflowInterface, getChatbotListNewReponseModel, globalWorkflowIntegrationType, staticWorkflowChatbotDetails } from '../models/axiosModel';
import { getExcetionActionType } from '../components/dashboard/flowBuilder/utilityFunctions';
import { CHATBOT_CHANNEL_NAME } from '../pages/ruleBasedInbox/channelConstants';

const WorkflowContext = React.createContext<WorkflowContextPayload | undefined>(undefined);

export interface WorkflowContextPayload {
    workflowList: workflowList[],
    setWorkflowList: React.Dispatch<React.SetStateAction<workflowList[]>>,

    flagNewWorkflowPopup: boolean,
    setFlagNewWorkflowPopup: React.Dispatch<React.SetStateAction<boolean>>,

    flagShowQRCodePopup: boolean, 
    setFlagShowQRCodePopup: React.Dispatch<React.SetStateAction<boolean>>,
    phoneNumberQR: string, 
    setPhoneNumberQR: React.Dispatch<React.SetStateAction<string>>, 
    qrChannelName: string,
    setQrChannelName: React.Dispatch<React.SetStateAction<string>>,
    conditionGroup: condition_group | null, 
    setConditionGroup: React.Dispatch<React.SetStateAction<condition_group | null>>,

    chatbotTypes: chatbotTypeResponseModel[] | null,
    setChatbotTypes: React.Dispatch<React.SetStateAction<chatbotTypeResponseModel[] | null>>,

    getChatbotTypes: () => Promise<void>,

    createNewWorkflowPayload: createWorkflowInterface,
    setCreateNewWorkflowPayload: React.Dispatch<React.SetStateAction<createWorkflowInterface>>,

    workflowIntegrationList: globalWorkflowIntegrationType[] | null,
    setWorkflowIntegrationList: React.Dispatch<React.SetStateAction<globalWorkflowIntegrationType[] | null>>,
    getWorkFlowIntergrationChannels: () => Promise<void>,

    isProcessing:  React.MutableRefObject<boolean>,

    existingWorkFlowList: getChatbotListNewReponseModel[] | null,
    setExistingWorkflowList: React.Dispatch<React.SetStateAction<getChatbotListNewReponseModel[] | null>>,
    getExistingWorkflowList: () => Promise<void>
    currentActiveStaticWorkflow: staticWorkflowChatbotDetails | null;
    setCurrentActiveStaticWorkflow: React.Dispatch<React.SetStateAction<staticWorkflowChatbotDetails | null>>;
    getWorkflowDetails: (chatbot_id: string) => Promise<CommonResponseModel<staticWorkflowChatbotDetails | null>>;
    updateChatbotDeploymentDetails: any,
    flagIntegrateBusinessAccountPopup: boolean, 
    setFlagIntegrateBusinessAccountPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

export interface workflowList {
    workflow_id: number,
    workflow_title: string,
    trigger_when: string,
    flag_live: boolean,
    status: string,
    runs: number,
    ctr: number,
    created_at_timestamp: string,
}

const defaultVal: workflowList[] = [
    {
        workflow_id: 1,
        workflow_title: "Auto-reply to comment in DM",
        trigger_when: "User comments on specific Postor Reel and comment contains keyword",
        flag_live: false,
        status: "Draft",
        runs: 0,
        ctr: 0,
        created_at_timestamp: "2024-03-19 11:35:06",
    },
    {
        workflow_id: 2,
        workflow_title: "Generate Leads with Stories",
        trigger_when: "User comments on Story",
        flag_live: false,
        status: "Completed",
        runs: 3,
        ctr: 0,
        created_at_timestamp: "2024-03-19 11:30:06",
    },
];

const WorkflowProvider = ({ children }: ChildrenProps) => {

    const [workflowList, setWorkflowList] = useState<workflowList[]>(defaultVal);

    const [flagNewWorkflowPopup, setFlagNewWorkflowPopup] = useState<boolean>(false);

    const [chatbotTypes, setChatbotTypes] = useState<chatbotTypeResponseModel[] | null>(null)
    const [createNewWorkflowPayload, setCreateNewWorkflowPayload] = useState<createWorkflowInterface>(initialCreateNewFlowObject);
    const [workflowIntegrationList, setWorkflowIntegrationList] = useState<globalWorkflowIntegrationType[] | null>(null);

    const isProcessing = useRef<boolean>(false);

    const [existingWorkFlowList, setExistingWorkflowList] = useState<getChatbotListNewReponseModel[] | null>(null)
    const [currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow] = useState<staticWorkflowChatbotDetails | null>(null)

    const [flagIntegrateBusinessAccountPopup, setFlagIntegrateBusinessAccountPopup] = useState<boolean>(false);

    const [flagShowQRCodePopup, setFlagShowQRCodePopup] = useState<boolean>(false);
    const [phoneNumberQR, setPhoneNumberQR] = useState<string>(""); 
    const [qrChannelName, setQrChannelName] = useState<string>(CHATBOT_CHANNEL_NAME.WHATSAPP);
    const [conditionGroup, setConditionGroup] = useState<condition_group | null>(null);

    const getWorkFlowIntergrationChannels = async () => {
        const responseMetaIntegration = await agent.getChannelList.get();
        if (responseMetaIntegration.status) {
            setWorkflowIntegrationList(responseMetaIntegration.data)
        }
        else {
            setWorkflowIntegrationList(null)
        }
    }

    const getChatbotTypes = async () => {
        const res = await agent.getChatbotType.get();
        if (res.status) {
            setChatbotTypes(res.data)
        }
        else {
            setChatbotTypes(null)
        }
    }

    const getExistingWorkflowList = async () => {
        const res = await agent.getChatbotConfig.get();
        if (res.status) {
            setExistingWorkflowList(res.data.filter((res: getChatbotListNewReponseModel) => res?.chatbot_type?.chatbot_type_name.toLowerCase() == "workflow"))
        }
        else {
            setExistingWorkflowList(null)
        }
    }
    const getWorkflowDetails = async (chatbot_id: string) => {
        const res = await agent.getChatbotConfig.get(chatbot_id);
        if (res.status) {
            let flow = { ...res.data[0] }
            let draftVersionIndex = res.data[0].chatbot_version_info.findIndex((version: any) => version.chatbot_version_status_name?.toLowerCase() == 'draft')
            if (draftVersionIndex == '-1') {
                let publishedVersion = res.data[0].chatbot_version_info.find((version: any) => version.chatbot_version_status_name?.toLowerCase() == 'published')
                let draftVersion = JSON.parse(JSON.stringify(publishedVersion))
                draftVersion.chatbot_version_status_name = 'Draft'
                flow.chatbot_version_info.push(draftVersion)
            }
            flow.currentViewVersion = "Draft" 
            flow.chatbot_exception = flow.chatbot_exception ? {
                ...flow.chatbot_exception, 
                flag_saved_in_BE: true,
                action_type: getExcetionActionType(flow.chatbot_exception?.flag_redeploy, flow.chatbot_exception?.flag_redirect, flow.chatbot_exception?.flag_do_nothing)
            } : flow.chatbot_exception;

            setCurrentActiveStaticWorkflow(flow)
        }
        else {
            setExistingWorkflowList(null)
        }
        return res
    }

    async function updateChatbotDeploymentDetails(payload: any) {
        const res = await agent.updateChatbotDeploymentDetails.put(payload)
        // if (res.status) {
        //     let flow = { ...res.data[0] }
        //     flow.currentViewVersion = "Draft"
        //     setCurrentActiveStaticWorkflow(flow)
        // }
        return res;
    }

    const payload = {
        workflowList,
        setWorkflowList,
        flagNewWorkflowPopup,
        setFlagNewWorkflowPopup,
        getChatbotTypes,
        chatbotTypes,
        setChatbotTypes,
        isProcessing,
        createNewWorkflowPayload,
        setCreateNewWorkflowPayload,
        workflowIntegrationList,
        setWorkflowIntegrationList,
        getWorkFlowIntergrationChannels,
        existingWorkFlowList,
        setExistingWorkflowList,
        getExistingWorkflowList,
        currentActiveStaticWorkflow,
        setCurrentActiveStaticWorkflow,
        getWorkflowDetails,
        updateChatbotDeploymentDetails,
        flagIntegrateBusinessAccountPopup, 
        setFlagIntegrateBusinessAccountPopup, 
        flagShowQRCodePopup, 
        setFlagShowQRCodePopup,
        phoneNumberQR, 
        setPhoneNumberQR, 
        qrChannelName,
        setQrChannelName,
        conditionGroup, 
        setConditionGroup
    }

    return (
        <WorkflowContext.Provider value={payload}>
            {children}
        </WorkflowContext.Provider>
    )
}

export { WorkflowContext, WorkflowProvider }
